'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _simpleMap = require('./simple-map');

var _simpleMap2 = _interopRequireDefault(_simpleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stylesIndex = new _simpleMap2.default();

exports.default = function (styles, styleNames, errorWhenNotFound) {
    var appendClassName = void 0,
        stylesIndexMap = void 0;

    stylesIndexMap = stylesIndex.get(styles);

    if (stylesIndexMap) {
        var styleNameIndex = stylesIndexMap.get(styleNames);

        if (styleNameIndex) {
            return styleNameIndex;
        }
    } else {
        stylesIndexMap = new _simpleMap2.default();
        stylesIndex.set(styles, new _simpleMap2.default());
    }

    appendClassName = '';

    for (var styleName in styleNames) {
        if (styleNames.hasOwnProperty(styleName)) {
            var className = styles[styleNames[styleName]];

            if (className) {
                appendClassName += ' ' + className;
            } else if (errorWhenNotFound === true) {
                throw new Error('"' + styleNames[styleName] + '" CSS module is undefined.');
            }
        }
    }

    appendClassName = appendClassName.trim();

    stylesIndexMap.set(styleNames, appendClassName);

    return appendClassName;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-css-modules/dist/generateAppendClassName.js
// module id = 1826
// module chunks = 47